module.exports = __webpack_public_path__ + "img/qph1.a545de23.jpg";